import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[dsNumbersOnly]'
})
export class NumbersOnlyDirective {

  regexStr = /^[0-9]*$/;
  constructor() {}

  @HostListener('keypress', ['$event'])
  onKeyPress(event) {
    return this.regexStr.test(event.key);
  }

}
